var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCk(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#41479B"
    },
    d: "M473.655,423.724H38.345C17.167,423.724,0,406.557,0,385.379V126.621 c0-21.177,17.167-38.345,38.345-38.345h435.31c21.177,0,38.345,17.167,38.345,38.345V385.38 C512,406.557,494.833,423.724,473.655,423.724z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M8.828,256h15.334l81.77-53.574V256h44.138v-53.574L231.839,256h15.334 c4.875,0,8.828-3.953,8.828-8.828v-7.002l-70.154-45.963H256v-44.138h-70.155L256,104.106v-7.002c0-4.874-3.95-8.825-8.823-8.828 h-15.338l-81.77,53.574V88.276h-44.138v53.574L26.844,90.034c-9.234,2.9-16.954,9.203-21.713,17.434l65.024,42.601H0v44.138h70.155 L0,240.17v7.002C0,252.047,3.953,256,8.828,256z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF4B55"
    },
    points: "256,158.897 141.241,158.897 141.241,88.276 114.759,88.276 114.759,158.897 0,158.897  0,185.379 114.759,185.379 114.759,256 141.241,256 141.241,185.379 256,185.379  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M8.227,102.902l72.662,47.167h16.214l-82.496-53.55C12.238,98.389,10.097,100.532,8.227,102.902z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M166.283,150.069l88.374-57.366c-1.536-2.599-4.246-4.427-7.485-4.427h-1.909l-95.194,61.793 H166.283z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M89.474,194.207L1.269,251.463C2.79,254.125,5.542,256,8.828,256h1.665l95.196-61.793H89.474z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M255.86,247.865l-82.666-53.658H156.98l93.874,60.935 C253.666,253.837,255.595,251.102,255.86,247.865z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M377.129,150.113l3.237,9.708l10.233,0.079c0.792,0.007,1.121,1.017,0.483,1.489l-8.232,6.079 l3.086,9.757c0.239,0.756-0.621,1.382-1.267,0.92l-8.326-5.951l-8.326,5.951c-0.646,0.461-1.505-0.164-1.267-0.92l3.086-9.757 l-8.232-6.079c-0.638-0.471-0.309-1.483,0.483-1.489l10.233-0.079l3.238-9.708C375.815,149.361,376.878,149.361,377.129,150.113z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M333.617,162.052l6.906,7.552l9.38-4.089c0.727-0.317,1.439,0.473,1.047,1.163l-5.048,8.902 l6.788,7.658c0.526,0.594-0.006,1.515-0.782,1.356l-10.026-2.05l-5.185,8.822c-0.402,0.683-1.442,0.462-1.532-0.326l-1.149-10.168 l-9.993-2.205c-0.775-0.171-0.885-1.229-0.163-1.557l9.316-4.235l-0.991-10.185C332.109,161.9,333.081,161.468,333.617,162.052z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M298.722,190.659l9.38,4.089l6.906-7.552c0.535-0.585,1.507-0.152,1.43,0.637l-0.991,10.185 l9.316,4.235c0.722,0.328,0.61,1.386-0.163,1.557l-9.993,2.205l-1.149,10.168c-0.089,0.788-1.13,1.009-1.532,0.326l-5.185-8.822 l-10.026,2.05c-0.777,0.159-1.309-0.762-0.782-1.356l6.788-7.658l-5.048-8.902C297.283,191.133,297.995,190.342,298.722,190.659z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M278.479,230.985l10.233-0.079l3.237-9.708c0.25-0.753,1.314-0.753,1.566,0l3.237,9.708 l10.233,0.079c0.792,0.007,1.121,1.017,0.483,1.489l-8.232,6.079l3.086,9.757c0.239,0.756-0.621,1.382-1.267,0.92l-8.326-5.951 l-8.326,5.951c-0.646,0.461-1.505-0.164-1.267-0.92l3.086-9.757l-8.232-6.079C277.358,232.002,277.687,230.99,278.479,230.985z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M276.39,276.057l9.316-4.235l-0.991-10.185c-0.077-0.789,0.895-1.221,1.43-0.637l6.906,7.552 l9.38-4.089c0.727-0.317,1.439,0.473,1.047,1.163l-5.048,8.902l6.788,7.658c0.526,0.594-0.006,1.515-0.782,1.356l-10.026-2.05 l-5.185,8.822c-0.402,0.683-1.442,0.462-1.532-0.326l-1.149-10.168l-9.993-2.205C275.778,277.443,275.668,276.385,276.39,276.057z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M292.812,318.083l6.788-7.658l-5.048-8.902c-0.391-0.69,0.321-1.48,1.047-1.163l9.38,4.089 l6.906-7.552c0.535-0.585,1.507-0.152,1.43,0.637l-0.991,10.185l9.316,4.235c0.722,0.328,0.61,1.386-0.163,1.557l-9.993,2.205 l-1.149,10.168c-0.089,0.788-1.13,1.009-1.532,0.326l-5.185-8.822l-10.026,2.05C292.818,319.597,292.286,318.676,292.812,318.083z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M324.908,349.796l3.086-9.757l-8.232-6.079c-0.638-0.471-0.309-1.483,0.483-1.489l10.233-0.079 l3.237-9.708c0.25-0.753,1.314-0.753,1.566,0l3.237,9.708l10.233,0.079c0.792,0.007,1.121,1.017,0.483,1.489l-8.232,6.079 l3.086,9.757c0.239,0.756-0.621,1.382-1.267,0.92l-8.326-5.951l-8.326,5.951C325.53,351.177,324.67,350.552,324.908,349.796z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M367.129,365.713l-1.149-10.168l-9.993-2.205c-0.775-0.171-0.885-1.229-0.163-1.557l9.316-4.235 l-0.991-10.185c-0.077-0.789,0.895-1.221,1.43-0.637l6.906,7.552l9.38-4.089c0.727-0.317,1.439,0.473,1.047,1.163l-5.048,8.902 l6.788,7.658c0.526,0.594-0.006,1.515-0.782,1.356l-10.026-2.05l-5.185,8.822C368.258,366.721,367.218,366.5,367.129,365.713z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M412.173,363.08l-5.185-8.822l-10.026,2.05c-0.777,0.159-1.309-0.763-0.782-1.356l6.788-7.658 l-5.048-8.901c-0.391-0.69,0.321-1.48,1.047-1.163l9.38,4.089l6.906-7.552c0.535-0.585,1.507-0.152,1.43,0.637l-0.991,10.185 l9.316,4.235c0.722,0.328,0.61,1.386-0.163,1.557l-9.993,2.205l-1.149,10.168C413.615,363.542,412.575,363.764,412.173,363.08z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M452.253,342.355l-8.326-5.951l-8.326,5.951c-0.646,0.461-1.505-0.164-1.267-0.92l3.086-9.757 l-8.232-6.079c-0.638-0.471-0.309-1.483,0.483-1.489l10.233-0.079l3.237-9.708c0.25-0.753,1.314-0.753,1.566,0l3.238,9.708 l10.233,0.079c0.792,0.007,1.121,1.017,0.483,1.489l-8.232,6.079l3.086,9.757C453.758,342.19,452.897,342.815,452.253,342.355z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M480.437,307.118l-10.026-2.05l-5.185,8.822c-0.402,0.683-1.442,0.462-1.532-0.326l-1.149-10.168 l-9.993-2.205c-0.775-0.171-0.885-1.229-0.163-1.557l9.316-4.235l-0.991-10.185c-0.077-0.789,0.895-1.222,1.43-0.637l6.906,7.552 l9.38-4.089c0.727-0.317,1.439,0.473,1.047,1.163l-5.048,8.901l6.788,7.658C481.746,306.356,481.214,307.277,480.437,307.118z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M491.853,263.466l-9.993,2.205l-1.149,10.168c-0.089,0.788-1.13,1.009-1.532,0.326l-5.185-8.822 l-10.026,2.05c-0.777,0.159-1.309-0.762-0.782-1.356l6.788-7.658l-5.048-8.902c-0.391-0.69,0.321-1.48,1.047-1.163l9.38,4.089 l6.906-7.552c0.535-0.585,1.507-0.152,1.43,0.637l-0.991,10.185l9.316,4.235C492.738,262.237,492.627,263.295,491.853,263.466z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M484.526,218.943l-8.232,6.079l3.086,9.757c0.239,0.756-0.621,1.382-1.267,0.92l-8.326-5.951 l-8.326,5.951c-0.646,0.461-1.505-0.164-1.267-0.92l3.086-9.757l-8.232-6.079c-0.638-0.471-0.309-1.483,0.483-1.489l10.233-0.079 l3.238-9.708c0.25-0.753,1.314-0.753,1.566,0l3.238,9.708l10.233,0.079C484.835,217.461,485.164,218.473,484.526,218.943z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M459.725,181.25l-5.048,8.902l6.788,7.658c0.526,0.594-0.006,1.515-0.782,1.356l-10.026-2.05 l-5.185,8.822c-0.402,0.683-1.442,0.462-1.532-0.326l-1.149-10.168l-9.993-2.205c-0.775-0.171-0.885-1.229-0.163-1.557l9.316-4.235 l-0.991-10.185c-0.077-0.789,0.895-1.222,1.43-0.637l6.906,7.552l9.38-4.089C459.404,179.77,460.116,180.561,459.725,181.25z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M421.736,156.904l-0.991,10.185l9.316,4.235c0.722,0.328,0.61,1.386-0.163,1.557l-9.993,2.205 l-1.149,10.168c-0.089,0.788-1.13,1.009-1.532,0.326l-5.185-8.822l-10.026,2.05c-0.777,0.159-1.309-0.762-0.782-1.356l6.788-7.658 l-5.048-8.902c-0.391-0.69,0.321-1.48,1.047-1.163l9.38,4.089l6.906-7.552C420.841,155.681,421.813,156.115,421.736,156.904z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M377.129,150.113l3.237,9.708l10.233,0.079c0.792,0.007,1.121,1.017,0.483,1.489l-8.232,6.079 l3.086,9.757c0.239,0.756-0.621,1.382-1.267,0.92l-8.326-5.951l-8.326,5.951c-0.646,0.461-1.505-0.164-1.267-0.92l3.086-9.757 l-8.232-6.079c-0.638-0.471-0.309-1.483,0.483-1.489l10.233-0.079l3.238-9.708C375.815,149.361,376.878,149.361,377.129,150.113z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCk);
export default __webpack_public_path__ + "static/media/ck.57ae9390c51a47ef80db2343853d8ec7.svg";
export { ForwardRef as ReactComponent };